// import './styles/AlertsByHost.css'
import React, { useEffect, useState } from 'react'
// import Select from 'react-select'
// import data_ubi from './ubicaciones'
// import { useFetch } from '../hooks/useFetch'
import { useFetch } from '../../../hooks/useFetch'
import RowProblem from './RowProblem'
import LoadAlerts from '../../LoadAlerts'
import { capitalizeFirstLetter } from '../../../utils/utils'
import { lang } from '../../generales/traduction'
const AlertsByHost=({dataCriticalities,dataAgencies,hostSelected,handleShowPopup,languaje,mode,hostId,userPermissions ,mapAux,ubiActual,setmapAux,server,search_problems,suveryId,setSuveryId,setImportModalOpen})=>{
  const token_item=localStorage.getItem('access_token')
  // const dataAgencies=useFetch('cassia/exception_agencies','',token_item,'GET',server)
  const [orderAsc,setOrderAsc]=useState(true)
  const [problems,setProblems]=useState()
  const [dataProblems,setDataProblems]=useState({data:[],loading:true,error:null})
  useEffect(()=>{
    search_problems()
  },[])
  function search_problems(){
    
    setDataProblems({data:dataProblems.data,loading:true,error:dataProblems.error})
      const fetchData = async () => {
        try {
          
            
      // console.log(server.url+'/api/v1/zabbix/problems/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter+((ubicacion.dispId==0 && ubicacion.templateId==0)?'?':'&')+severityfilter)
          const response = await fetch(server.url+'/api/v1/zabbix/hosts/detail/alerts/'+hostSelected.hostid, {                 
                              headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                              },
                            });
          if (response.ok) {
            const response_data = await response.json();
            setProblems(response_data.data)
            setDataProblems({data:response_data.data,loading:false,error:dataProblems.error})
          } else {
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
          // Manejo de errores
          
          setDataProblems({data:dataProblems.data,loading:dataProblems.loading,error:error})
          //console.error(error);
        }
      };
      fetchData();
    }
  const formatDateTime = (dateTimeString) => {
    // Dividir la cadena en fecha y hora
    const [datePart, timePart] = dateTimeString.split(' ');
  
    // Dividir la parte de la fecha en día, mes y año
    const [day, month, year] = datePart.split('/');
  
    // Reconstruir la cadena en el formato deseado
    const formattedDateTime = `${year}/${month}/${day} ${timePart}`;
  
    return formattedDateTime;
  };

  const orderBy = (attr) => {
    if (problems.length === 0) {
      return;
    }

    const sortedData = [...problems].sort((a, b) => {
        if (orderAsc) {
          setOrderAsc(false)
            if (formatDateTime(a[attr]) > formatDateTime(b[attr])) return 1;
            if (formatDateTime(a[attr]) < formatDateTime(b[attr])) return -1;
        } else {
          setOrderAsc(true)
            if (formatDateTime(a[attr]) < formatDateTime(b[attr])) return 1;
            if (formatDateTime(a[attr]) > formatDateTime(b[attr])) return -1;
        }
        return 0;
    });

    // if (orderAsc) {
    //     console.log('Ascendente', sortedData);
    // } else {
    //     console.log('Descendente', sortedData);
    // }

    // Actualizar estado o hacer lo que necesites con sortedData
    setProblems(sortedData);
};
  return(
      <div className='mh-alerts-container'>
         <div className='mh-alerts-header'>
            <div className='mh-alert-hcell' style={{width:'6%'}}>{capitalizeFirstLetter(lang[languaje]['severidad'])}</div>
            <div className='mh-alert-hcell' style={{width:'19%'}}>{capitalizeFirstLetter(lang[languaje]['Incidencia'])}</div>
            <div className='mh-alert-hcell' style={{width:'26%'}}>{capitalizeFirstLetter(lang[languaje]['dispositivo'])}</div>
            <div className='mh-alert-hcell' style={{width:'10%'}}>{capitalizeFirstLetter(lang[languaje]['Estatus'])}</div>
            <div className='mh-alert-hcell' style={{width:'4%'}}>ODD</div>
            <div className='mh-alert-hcell' style={{width:'4%'}}>DDT</div>
            <div className='mh-alert-hcell' style={{width:'5%'}}>Ack</div>
            <div className='mh-alert-hcell' style={{width:'5%'}}>Ticket</div>
            <div className='mh-alert-hcell' style={{width:'5%'}}>SLA</div>
            <div className='mh-alert-hcell' style={{width:'10%'}}>{capitalizeFirstLetter(lang[languaje]['tiempoEvento'])}</div>
            <div className='mh-alert-hcell mh-alert-sort' style={{width:'6%', cursor:'pointer'}} onClick={()=>orderBy('Time')}>
              {capitalizeFirstLetter(lang[languaje]['fecha'])} <span style={{marginLeft:'4px'}}>{(!orderAsc)?'▲':'▼'}</span>
            </div>
            <div className='mh-alert-hcell' style={{width:'6%'}}>{capitalizeFirstLetter(lang[languaje]['hora'])}</div>
         </div>
         <div className='mh-alerts-body'>
              {
                dataProblems.loading ? <LoadAlerts languaje={languaje}/> : (
                  problems.length===0 ? <div className='mh-search-empty' style={{marginTop:'40px'}}>Sin Resultados</div> :
                  problems.map((elemento, indice)=>(
                    <RowProblem languaje={languaje} setImportModalOpen={setImportModalOpen} setSuveryId={setSuveryId} handleShowPopup={handleShowPopup} mode={mode} userPermissions={userPermissions} ubiActual={ubiActual} mapAux={mapAux} setmapAux={setmapAux} search_problems={search_problems} key={indice} severity={elemento.severity} dataCriticalities={dataCriticalities}  dataAgencies={dataAgencies} data={elemento}  server={server} />
                  ))
                )
              }
         </div>
      </div>
  )
}

export default AlertsByHost